export default __webpack_public_path__ + "static/media/starIcon.67c56a8a.svg";